import React from "react";
import { Link } from "react-router-dom";

// Given real room rather than being one more section. The two paths are the
// whole product, so they get equal weight and enough whitespace that the page
// reads as finished rather than as having run out.

export default function FinalCta() {
    return (
        <section className="fc">
            <div className="fc__inner">
                <h2 className="fc__title">Ready to put something<br />on a screen?</h2>
                {/* The two-sided explanation lives in TwoSides now. Repeating
                    it here was the page explaining itself for a fourth time on
                    the way out. */}
                <p className="fc__lede">
                    Find a local screen, pick your dates, and put yourself out
                    there. Or host one and earn from the wall you already have.
                </p>
                <div className="fc__actions">
                    <Link to="/devices" className="wb-btn wb-btn--primary wb-btn--lg">
                        Explore locations
                    </Link>
                    <Link to="/waitlist" className="wb-btn wb-btn--secondary wb-btn--lg">
                        Become a host
                    </Link>
                </div>
            </div>
        </section>
    );
}
